import { Tooltip } from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import { useSelector, useDispatch } from "react-redux";
import { Check as CheckIcon, Remove as RemoveIcon } from "@mui/icons-material";

import { textFilter } from "utils/table";
import { useGetReferringProvidersQuery } from "app/store/referringProvider/api/referringProviderApi";
import {
  setShowReferringProviderModal,
  setIsProcessing,
  setIsUpdateOperation,
  setSelectedReferringProvider,
  setShowDeleteConfirmationModal,
} from "app/store/referringProvider/slice/referringProviderSlice";

const useReferringProviders = () => {
  const {
    showReferringProviderModal,
    isUpdateOperation,
    isProcessing,
    showDeleteConfirmationModal,
  } = useSelector((state) => state.referringProvider);
  const { data: referringProviders, isFetching } =
    useGetReferringProvidersQuery();
  const dispatch = useDispatch();

  const closeInsuranceModal = () => {
    dispatch(setShowReferringProviderModal(false));
  };

  const handleAddReferringProvider = () => {
    dispatch(setIsUpdateOperation(false));
    dispatch(setSelectedReferringProvider(null));
    dispatch(setShowReferringProviderModal(true));
  };

  const handleUpdateReferringProvider = (selectedReferringProvider) => {
    dispatch(setIsUpdateOperation(true));
    dispatch(setSelectedReferringProvider(selectedReferringProvider));
    dispatch(setShowReferringProviderModal(true));
  };

  const handleDeleteReferringProvider = (selectedReferringProvider) => {
    dispatch(setSelectedReferringProvider(selectedReferringProvider));
    dispatch(setShowDeleteConfirmationModal(true));
  };

  const columns = [
    {
      header: "Provider code",
      accessorKey: "provider_code",
      filterVariant: "text",
      filterFn: textFilter,
    },
    {
      header: "Provider Name",
      accessorKey: "name",
      filterVariant: "text",
      filterFn: textFilter,
    },
    {
      header: "NPI",
      accessorKey: "npi",
      filterVariant: "text",
      filterFn: textFilter,
    },
    {
      header: "Account",
      accessorKey: "account",
      filterVariant: "text",
      filterFn: textFilter,
    },
    {
      header: "Default Provider",
      accessorKey: "default",
      filterFn: (row, id, filterValue) => {
        const cellValue = row.getValue(id);
        return cellValue
          .toString()
          .toLowerCase()
          .includes(filterValue.toLowerCase());
      },
      filterVariant: "select",
      filterSelectOptions: [
        { label: "All", value: "" },
        { label: "Yes", value: "true" },
        { label: "No", value: "false" },
      ],
      Cell: ({ cell }) => (cell?.getValue() ? <CheckIcon /> : <RemoveIcon />),
      size: 50,
    },
    {
      header: "Street Address",
      accessorKey: "street",
      filterVariant: "text",
      filterFn: textFilter,
    },
    {
      header: "State",
      accessorKey: "state",
      filterVariant: "text",
      filterFn: textFilter,
    },
    {
      header: "Zip",
      accessorKey: "zip",
      filterVariant: "text",
      filterFn: textFilter,
    },
    {
      header: "Actions",
      accessor: "actions",
      enableColumnFilter: false,
      enableSorting: false,
      size: 100,
      accessorFn: (rowData) => {
        return (
          <div>
            <Tooltip title={"Edit"}>
              <EditOutlinedIcon
                className="action-buttons__edit"
                style={{ color: "#757575" }}
                onClick={() => handleUpdateReferringProvider(rowData)}
              />
            </Tooltip>

            <Tooltip title={"Delete"}>
              <DeleteOutlinedIcon
                style={{ color: "#757575" }}
                className="action-buttons__edit ml-2"
                onClick={() => handleDeleteReferringProvider(rowData)}
              />
            </Tooltip>
          </div>
        );
      },
    },
  ];

  return {
    columns,
    referringProviders,
    isFetching,
    showReferringProviderModal,
    setShowReferringProviderModal,
    isUpdateOperation,
    closeInsuranceModal,
    handleAddReferringProvider,
    handleUpdateReferringProvider,
    isProcessing,
    setIsProcessing,
    showDeleteConfirmationModal,
  };
};

export default useReferringProviders;
